import { ApolloError } from '@apollo/client';

import { toast } from '@/common/components/shared/toaster/toast';

export class ApiUtils {
  static getErrorMessage = (error: unknown) => {
    try {
      if (error instanceof ApolloError) {
        const code = error.graphQLErrors?.[error?.graphQLErrors.length - 1]?.extensions?.detail;

        if (code && typeof code === 'string') {
          return code;
        }

        if (error.message) {
          return error.message;
        }
      }

      if (typeof error === 'string') {
        return error;
      }

      return 'An error has occurred.';
    } catch (_error) {
      return 'An error has occurred.';
    }
  };

  static handleApiError = (error: string | ApolloError) => {
    try {
      const message = ApiUtils.getErrorMessage(error);
      toast.error(message);
    } catch {
      toast.error('An error has occurred.');
    }
  };
}
